import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-folder",
  "use": "icon-folder-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-folder\">\n<path d=\"M13.632 3.63999H7.99996L6.59196 2.23999H2.36796C1.59356 2.23999 0.959961 2.86999 0.959961 3.63999V12.04C0.959961 12.81 1.59356 13.44 2.36796 13.44H13.632C14.4064 13.44 15.04 12.81 15.04 12.04V5.03999C15.04 4.26999 14.4064 3.63999 13.632 3.63999ZM13.632 12.04H2.36796V5.03999H13.632V12.04Z\" fill=\"#465669\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol